export default "__VITE_ASSET__B3bM0j8X__"